(function (window, document) {
  'use strict';

  var core = window.scUpsellCore;
  if (!core || window.__scUpsellCoordinator) return;

  var ROOT_SELECTOR = '[data-sc-upsell-offer][data-sc-upsell-enabled="true"][data-sc-upsell-config-valid="true"][data-sc-upsell-direct="true"]';
  var registry = Object.create(null);
  var enqueue = core.createSerialQueue();
  var cartLockDepth = 0;

  window.__scUpsellCoordinator = {
    installed: true,
    pending: function (offerId, parentOperationId, parentKey) {
      var relationship = String(parentOperationId || '') || (parentKey ? 'key:' + String(parentKey) : '');
      var identity = String(offerId || '') + '::' + relationship;
      return !!(registry[identity] && registry[identity].controller.pending);
    }
  };

  function identityOf(root) {
    var parentOperationId = String(root.getAttribute('data-sc-upsell-parent-operation-id') || '');
    var parentKey = String(root.getAttribute('data-sc-upsell-parent-key') || '');
    return String(root.getAttribute('data-sc-upsell-offer-id') || '') + '::'
      + (parentOperationId || (parentKey ? 'key:' + parentKey : ''));
  }

  function route(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = typeof root === 'string' && root ? root : '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + path.replace(/^\//, '');
  }

  function rootsFor(identity) {
    return Array.prototype.filter.call(document.querySelectorAll(ROOT_SELECTOR), function (root) {
      return identityOf(root) === identity;
    });
  }

  function activateRoot(root) {
    if (!root || root.getAttribute('data-sc-upsell-ready') === 'true') return;
    root.setAttribute('data-sc-upsell-ready', 'true');
    var checkbox = root.querySelector('[data-sc-upsell-checkbox]');
    var existing = registry[identityOf(root)];
    if (checkbox && existing && existing.controller.desired) {
      checkbox.checked = existing.controller.desired.checked;
    }
    if (checkbox) checkbox.disabled = false;
    root.classList.toggle('is-selected', !!(checkbox && checkbox.checked));
    if (!existing && checkbox && checkbox.checked
      && root.getAttribute('data-sc-upsell-default-checked') === 'true') {
      requestState(root);
    }
  }

  function activateAll(scope) {
    var owner = scope && scope.querySelectorAll ? scope : document;
    if (owner.matches && owner.matches(ROOT_SELECTOR)) activateRoot(owner);
    var roots = owner.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i += 1) activateRoot(roots[i]);
  }

  function setStatus(identity, message, isError) {
    rootsFor(identity).forEach(function (root) {
      root.classList.toggle('has-error', !!isError);
      var status = root.querySelector('[data-sc-upsell-status]');
      if (status) status.textContent = message || '';
    });
  }

  function setOfferBusy(identity, busy) {
    rootsFor(identity).forEach(function (root) {
      root.classList.toggle('is-pending', busy);
      root.setAttribute('aria-busy', busy ? 'true' : 'false');
    });
    lockCartControls(busy);
    if (busy) setStatus(identity, 'Updating…', false);
  }

  function lockCartControls(locked) {
    if (locked) cartLockDepth += 1;
    else cartLockDepth = Math.max(0, cartLockDepth - 1);
    if (!locked && cartLockDepth > 0) return;

    var controls = document.querySelectorAll(
      'cart-drawer quantity-input button, cart-drawer quantity-input input, cart-drawer cart-remove-button button, cart-items quantity-input button, cart-items quantity-input input, #checkout, #CartDrawer-Checkout'
    );
    for (var i = 0; i < controls.length; i += 1) {
      var control = controls[i];
      if (locked) {
        if (!control.disabled) {
          control.disabled = true;
          control.setAttribute('data-sc-upsell-locked', '');
        }
      } else if (control.hasAttribute('data-sc-upsell-locked')) {
        control.disabled = false;
        control.removeAttribute('data-sc-upsell-locked');
      }
    }

    var anchors = document.querySelectorAll('cart-items cart-remove-button a');
    for (var j = 0; j < anchors.length; j += 1) {
      var anchor = anchors[j];
      if (locked) {
        if (!anchor.hasAttribute('aria-disabled')) {
          anchor.setAttribute('aria-disabled', 'true');
          anchor.setAttribute('tabindex', '-1');
          anchor.setAttribute('data-sc-upsell-locked', '');
        }
      } else if (anchor.hasAttribute('data-sc-upsell-locked')) {
        anchor.removeAttribute('aria-disabled');
        anchor.removeAttribute('tabindex');
        anchor.removeAttribute('data-sc-upsell-locked');
      }
    }
  }

  function waitForCartIdle(maxWaitMs) {
    return new Promise(function (resolve) {
      var waited = 0;
      (function check() {
        if (!window.__scCartMutationPending) return resolve(true);
        if (waited >= maxWaitMs) return resolve(false);
        waited += 100;
        window.setTimeout(check, 100);
      })();
    });
  }

  function sectionIds(drawer) {
    var values = [];
    var declared = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender()
      : [{ id: 'cart-drawer' }, { id: 'cart-icon-bubble' }];
    declared.forEach(function (entry) {
      if (entry && entry.id && values.indexOf(entry.id) === -1) values.push(entry.id);
    });

    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var element = document.getElementById(id);
      var sectionId = element && element.getAttribute('data-id');
      if (sectionId && values.indexOf(sectionId) === -1) values.push(sectionId);
    });
    return values;
  }

  async function refreshCartSurfaces() {
    var drawer = document.querySelector('cart-drawer');
    var ids = sectionIds(drawer);
    if (!ids.length) throw new Error('Upsell cart sections are unavailable');

    var results = await Promise.all([
      window.fetch(route('?sections=' + ids.map(encodeURIComponent).join(',')), {
        headers: { Accept: 'application/json' }
      }),
      window.fetch(route('cart.js'), { headers: { Accept: 'application/json' } })
    ]);
    if (!results[0].ok || !results[1].ok) throw new Error('Upsell cart refresh failed');

    var sections = await results[0].json();
    var cart = await results[1].json();
    var complete = ids.every(function (id) {
      return typeof sections[id] === 'string' && sections[id].length > 0;
    });
    if (!complete || !cart || typeof cart.item_count !== 'number') {
      throw new Error('Upsell cart refresh response is incomplete');
    }

    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ sections: sections }, true);
      drawer.classList.toggle('is-empty', cart.item_count === 0);
    }

    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var current = document.getElementById(id);
      if (!current) return;
      var currentSectionId = current.getAttribute('data-id');
      if (!currentSectionId || !sections[currentSectionId]) return;
      var parsed = new window.DOMParser().parseFromString(sections[currentSectionId], 'text/html');
      var replacement = parsed.getElementById('shopify-section-' + currentSectionId);
      var currentSection = document.getElementById('shopify-section-' + currentSectionId);
      if (replacement && currentSection) currentSection.innerHTML = replacement.innerHTML;
    });

    activateAll(document);
    if (cartLockDepth > 0) {
      lockCartControls(true);
      lockCartControls(false);
    }
    return cart;
  }

  function getState(root) {
    var offerId = root.getAttribute('data-sc-upsell-offer-id') || '';
    var parentOperationId = root.getAttribute('data-sc-upsell-parent-operation-id') || '';
    var parentKey = root.getAttribute('data-sc-upsell-parent-key') || '';
    var identity = identityOf(root);
    if (registry[identity]) {
      return registry[identity];
    }

    var state = { identity: identity };
    var transport = core.createCartTransport({
      fetch: window.fetch.bind(window),
      offerId: offerId,
      offerKind: root.getAttribute('data-sc-upsell-kind') || 'cross_sell',
      triggerProductId: root.getAttribute('data-sc-upsell-trigger-product-id') || '',
      parentOperationId: parentOperationId,
      parentKey: parentKey,
      cartUrl: route('cart.js'),
      addUrl: route('cart/add.js'),
      changeUrl: route('cart/change.js'),
      onConfirmed: function (detail) {
        document.dispatchEvent(new window.CustomEvent('sc:upsell-confirmed', { detail: detail }));
      }
    });

    state.controller = core.createIntentController({
      enqueue: enqueue,
      converge: async function (desired) {
        var idle = await waitForCartIdle(5000);
        if (!idle) throw new Error('Another cart update is still pending');
        return transport.converge(desired);
      },
      refresh: refreshCartSurfaces,
      recover: refreshCartSurfaces,
      onBusy: function (busy) { setOfferBusy(identity, busy); },
      onSettled: function (desired) {
        rootsFor(identity).forEach(function (current) {
          var checkbox = current.querySelector('[data-sc-upsell-checkbox]');
          if (checkbox) checkbox.checked = desired.checked;
          current.classList.toggle('is-selected', desired.checked);
          current.setAttribute('data-selected', desired.checked ? 'true' : 'false');
        });
        setStatus(identity, desired.checked ? 'Added to cart' : 'Removed from cart', false);
      },
      onError: function () {
        setStatus(identity, 'Could not update this offer. Please try again.', true);
      }
    });

    registry[identity] = state;
    return state;
  }

  function updateVariant(root, select) {
    var option = select.options[select.selectedIndex];
    root.setAttribute('data-sc-upsell-variant-id', select.value);
    var price = root.querySelector('[data-sc-upsell-price]');
    var compare = root.querySelector('[data-sc-upsell-compare-price]');
    if (price && option) price.textContent = option.getAttribute('data-price-label') || '';
    if (compare && option) {
      var compareLabel = option.getAttribute('data-compare-label') || '';
      compare.textContent = compareLabel;
      compare.classList.toggle('hidden', !compareLabel);
    }
  }

  function requestState(root) {
    var checkbox = root.querySelector('[data-sc-upsell-checkbox]');
    if (!checkbox) return;
    var state = getState(root);
    state.controller.request({
      checked: checkbox.checked,
      variantId: root.getAttribute('data-sc-upsell-variant-id') || ''
    }).catch(function () {});
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var root = target.closest(ROOT_SELECTOR);
    if (!root) return;

    if (target.matches('[data-sc-upsell-variant]')) {
      updateVariant(root, target);
      var checkbox = root.querySelector('[data-sc-upsell-checkbox]');
      if (!checkbox || !checkbox.checked) return;
    } else if (!target.matches('[data-sc-upsell-checkbox]')) {
      return;
    }

    root.classList.toggle('is-selected', !!root.querySelector('[data-sc-upsell-checkbox]:checked'));
    requestState(root);
  });

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('[data-sc-upsell-child-remove]');
    if (!button) return;
    var root = button.closest(ROOT_SELECTOR);
    if (!root) return;
    var checkbox = root.querySelector('[data-sc-upsell-checkbox]');
    if (!checkbox) return;
    checkbox.checked = false;
    root.classList.remove('is-selected');
    requestState(root);
  });

  function install() {
    activateAll(document);
    if (typeof window.MutationObserver !== 'function' || !document.body) return;
    new window.MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        for (var i = 0; i < mutation.addedNodes.length; i += 1) {
          var node = mutation.addedNodes[i];
          if (node && node.nodeType === 1) activateAll(node);
        }
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install);
  else install();
})(window, document);
